'use client';

import { createContext, useContext } from 'react';
import { noop } from 'utils/noop';
import type { OnRequestClose } from './types';

export const DialogContext = createContext<{
  onRequestClose: OnRequestClose;
  id: string;
}>({ onRequestClose: noop, id: '' });

export const useDialogContext = () => useContext(DialogContext);
